import { Component } from '@angular/core';
import { GoodType } from 'wms-lib';
import { CatalogComponent } from '../../base-components/catalog.component';

@Component({
    selector: 'app-good-types',
    templateUrl: './good-types.component.html',
    styleUrls: ['./good-types.component.sass']
})
export class GoodTypesComponent extends CatalogComponent<GoodType> {
    name_catalog = 'good_types';
    title = 'Good Types';


    addNew(_type?: string) {
        let c = this.newItem({name_es: '', name_en: '', type: _type});
        this.items[c.id] = c;
        this.items = {...this.items};
    }

    newItem(data: any) {
      return new GoodType(data);
    }
}
